<template>
  <div>
    <div v-for="(el, i) in model" :key="i">
      <component
        v-if="el.type"
        :is="'a-input-' + el.type"
        :model="el"
        :values="data"
        :value="data[el.name]"
        :config="config"
        readonly
      ></component>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    model: Array,
    errors: Object,
    config: { type: Object, default: { dense: false, hideDetails: false } },
  },
  computed: {
    data: {
      set(v) {
        this.$emit("input", v);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    async onInput(e, el) {
      if (typeof e === "object" && e !== null) {
        Object.assign(this.data, e);
      } else {
        this.data[el.name] = e;
      }
      this.$emit("validate", el.name);
    },
  },
};
</script>